import { ReactNode } from 'react';
import Dropzone from 'react-dropzone';
import * as R from 'ramda';

import {
  Flex,
  Text,
} from 'web-styled';
import {
  Modal,
  Button,
} from 'web-components';

import File from './File';
import * as S from './styled';

type FileUpload = {
  [k: number]: {
    name: string,
  },
};

type Props = {
  title?: string;
  accept?: string;
  isOpen: boolean;
  isLoaded: boolean;
  multiple?: boolean;
  helpText?: string
  fileUpload: FileUpload;
  placeholder?: ReactNode;
  resourceType: string;
  onRequestDrop: { (files: any[]): void };
  onRequestClose: { (): void };
  onRequestCancel: { (): void };
};

const FileUploader = ({
  title = 'Upload files',
  accept = '',
  isOpen,
  multiple = true,
  helpText,
  isLoaded,
  placeholder = 'Drop your files here or',
  fileUpload,
  resourceType,
  onRequestDrop,
  onRequestClose,
  onRequestCancel,
}: Props) => {
  const hasFile = isLoaded && !R.isEmpty(fileUpload)
  return (
    <Modal
      title={title}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <Flex column width="100%" spacing={25}>
        <Dropzone multiple={multiple} accept={accept} onDrop={onRequestDrop}>
          {({ getRootProps, getInputProps, isDragActive }) => (
            <S.StyledDropArea
              {...getRootProps()}
              isDragActive={isDragActive}
            >
              <input {...getInputProps()} />
              <Text color="#808080">
                {placeholder}
              </Text>
              <Button
                ghost
                appearance={isDragActive ? 'success' : 'primary'}
              >
                Upload From Computer
              </Button>
            </S.StyledDropArea>
          )}
        </Dropzone>
        {!R.isEmpty(fileUpload) && (
          <Flex
            column
            spacing={15}
            width="100%"
          >
            {Object.keys(fileUpload).map(key => (
              <File
                key={key}
                file={fileUpload[key]}
                source={key}
                fileUpload={fileUpload}
                resourceType={resourceType}
              />
            ))}
          </Flex>
        )}
        <Flex width="100%" justify="flex-end">
          <Button
            ghost
            appearance={hasFile ? 'primary' : 'danger'}
            onClick={() => (hasFile
              ? onRequestCancel()
              : onRequestClose()
            )}
          >
            {hasFile ? 'Finish' : 'Cancel'}
          </Button>
        </Flex>
        {helpText && (
          <>
            <hr style={{ marginBottom: 15 }} />
            <Text color="#9EA0A1" dangerouslySetInnerHTML={{ __html: helpText }} />
          </>
        )}
      </Flex>
    </Modal>
  )
}

export default FileUploader;
